/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImporterSupportedFile {
    JSON = 'json',
    XLSX = 'xlsx',
    CSV = 'csv',
}
